import { createAction, props } from '@ngrx/store';

export const downloadCollection = createAction(
  '[Filter Results Page] Download Collection',
  props<{ id: number; language: string; filterValues?: number[]; searchTerm?: string }>()
);

export const downloadCollectionSuccess = createAction(
  '[Downloadcenter/Api] Download Collection Success',
  props<{ data: string }>()
);

export const downloadCollectionFailure = createAction(
  '[Downloadcenter/Api] Download Collection Failure',
  props<{ error: any }>()
);
